import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import fetchBase from "../utils/fetchBase";

export default function EmployeeDocumentHubPage() {
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const authHeader = "Bearer " + localStorage.getItem("jwt_token");

    useEffect(() => {
        fetch(`${fetchBase}/api/document-hub/employee/my-hub`, {
            headers: { Authorization: authHeader }
        })
            .then(res => res.json())
            .then(data => {
                const allDocs = (data.sections || []).flatMap(s => s.documents || []);
                setDocuments(allDocs);
            })
            .catch(err => console.error("Failed to fetch my hub:", err))
            .finally(() => setLoading(false));
    }, []);

    const regular = documents.filter(d => !d.isDynamic);
    const dynamic = documents.filter(d => d.isDynamic && d.status !== "COMPLETED");
    const completedDynamic = documents.filter(d => d.isDynamic && d.status === "COMPLETED");

    const renderCard = (doc) => (
        <div
            key={doc.id}
            onClick={() => navigate(`/employee/document-hub/documents/${doc.id}`)}
            style={{
                background: "#fff",
                borderRadius: "14px",
                padding: "24px 20px",
                border: "1px solid #e0e0e0",
                cursor: "pointer",
                position: "relative",
                boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                transition: "box-shadow 0.2s, border-color 0.2s"
            }}
            onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.12)"}
            onMouseLeave={e => e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.06)"}
        >
            {doc.isDynamic && (
                <span style={{
                    position: "absolute", top: "10px", right: "10px",
                    width: "8px", height: "8px", borderRadius: "50%",
                    background: doc.status === "COMPLETED" ? "#34c759" : "#ff9500"
                }} />
            )}
            <div style={{ fontSize: "28px", marginBottom: "12px" }}>
                {doc.fileType === "DOCX" || doc.fileType === "DOC" ? "📝" : "📄"}
            </div>
            {doc.isDynamic && (
                <p style={{ fontWeight: "700", fontSize: "13px", color: "#0071e3", margin: "0 0 4px" }}>{doc.assignmentTitle}</p>
            )}
            <p style={{ fontWeight: "600", fontSize: "13px", color: "#1d1d1f", margin: 0, wordBreak: "break-word" }}>{doc.filename}</p>
            <p style={{ fontSize: "11px", color: "#6e6e73", marginTop: "6px" }}>{doc.uploadedDate}</p>
        </div>
    );

    return (
        <div style={{ minHeight: "100vh", background: "#f5f5f7" }}>
            <nav className="apple-global-nav">
                <div className="left-nav">
                    <img
                        src="/images/logoPlaceholder1.png"
                        alt="Logo"
                        className="apple-logo"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/employee/dashboard")}
                    />
                </div>
                <div className="center-nav">
                    <a href="/employee/dashboard">Dashboard</a>
                </div>
            </nav>
            <div style={{ maxWidth: "1000px", margin: "60px auto", padding: "0 20px" }}>
                <h1 style={{ fontSize: "28px", fontWeight: "700", color: "#1d1d1f", marginBottom: "24px" }}>Document Hub</h1>
                {loading ? (
                    <p style={{ color: "#6e6e73", fontSize: "14px" }}>Loading...</p>
                ) : (
                    <>
                        <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1d1d1f", margin: "10px 0 14px" }}>Assignments</h2>
                        {regular.length === 0 ? (
                            <p style={{ color: "#6e6e73", fontSize: "14px" }}>No assignments yet.</p>
                        ) : (
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "20px" }}>
                                {regular.map(renderCard)}
                            </div>
                        )}
                        <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1d1d1f", margin: "30px 0 14px" }}>Dynamic Assignments</h2>
                        {dynamic.length === 0 ? (
                            <p style={{ color: "#6e6e73", fontSize: "14px" }}>No dynamic assignments yet.</p>
                        ) : (
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "20px" }}>
                                {dynamic.map(renderCard)}
                                            </div>
                                        )}
                                        <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1d1d1f", margin: "30px 0 14px" }}>Completed Dynamic Assignments</h2>
                                        {completedDynamic.length === 0 ? (
                                            <p style={{ color: "#6e6e73", fontSize: "14px" }}>No completed dynamic assignments yet.</p>
                                        ) : (
                                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "20px" }}>
                                                {completedDynamic.map(renderCard)}
                                            </div>
                                        )}
                                    </>
                                )}
            </div>
        </div>
    );
}